/// <reference types="vite/client" />
import React from "react";
import { createRoot } from "react-dom/client";
import App from "@/components/App";
import "@/app/globals.css";
import "@/app/dashboard.css";
import "@/app/cloud.css";
import "@/app/glass.css";
import { AQUA_PORTAL_FUNCTION_URL, AQUA_REALTIME_FUNCTION_URL, SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "@/lib/publicConfig";

if (import.meta.env.MODE !== "pwa") document.documentElement.dataset.aquadrawNative = "true";
const realtimeUrl = import.meta.env.VITE_AQUA_REALTIME_URL?.trim() || AQUA_REALTIME_FUNCTION_URL;
if (realtimeUrl) document.documentElement.dataset.aquaRealtimeUrl = realtimeUrl;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() || SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() || SUPABASE_PUBLISHABLE_KEY;
const portalFunctionUrl = import.meta.env.VITE_AQUA_PORTAL_FUNCTION_URL?.trim() || AQUA_PORTAL_FUNCTION_URL;
if (supabaseUrl) document.documentElement.dataset.supabaseUrl = supabaseUrl;
if (supabasePublishableKey) document.documentElement.dataset.supabasePublishableKey = supabasePublishableKey;
if (portalFunctionUrl) document.documentElement.dataset.portalFunctionUrl = portalFunctionUrl;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode><App /></React.StrictMode>,
);
